/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailalreadyverifiederror3Inputs */

const en_emailalreadyverifiederror3 = /** @type {(inputs: Emailalreadyverifiederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email has already been verified.`)
};

const de_emailalreadyverifiederror3 = /** @type {(inputs: Emailalreadyverifiederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse wurde bereits bestätigt.`)
};

/**
* | output |
* | --- |
* | "Email has already been verified." |
*
* @param {Emailalreadyverifiederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailalreadyverifiederror3 = /** @type {((inputs?: Emailalreadyverifiederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailalreadyverifiederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailalreadyverifiederror3(inputs)
	return de_emailalreadyverifiederror3(inputs)
});
export { emailalreadyverifiederror3 as "emailAlreadyVerifiedError" }